<template>
    <div class="w-full flex flex-col bg-gradient-to-br from-gray-100 to-blue-50">
        <div class="flex flex-col border border-ternary">
            <h1 class="text-2xl font-bold bg-ternary text-white px-4 py-2">Applicant’s Information</h1>
            <div class="flex">
                <div class="flex-shrink-0 border-r border-ternary">
                    <img v-if="item.profile_picture_url" class="h-48 object-contain" :src="getProfilePicture">
                    <img v-else class="h-48" src="../../assets/images/default/avatar.jpg">
                </div>
                <div class="flex-grow flex flex-col justify-between">
                    <div class="flex flex-row border-b border-ternary flex-grow">
                        <div class="w-1/4 font-bold border-r border-ternary px-2 py-1  flex items-center">Full Name
                        </div>
                        <div class="w-3/4 px-2 py-1  flex items-center">{{ item.full_name }}</div>
                    </div>
                    <div class="flex flex-row border-b border-ternary flex-grow">
                        <div class="w-1/4 font-bold border-r border-ternary px-2 py-1  flex items-center">Previous Name
                        </div>
                        <div class="w-3/4 px-2 py-1  flex items-center">{{ item.previous_name }}</div>
                    </div>
                    <div class="flex flex-row border-b border-ternary flex-grow">
                        <div class="w-1/2 flex flex-row">
                            <div class="w-1/2 font-bold border-r border-ternary px-2 py-1  flex items-center">Current
                                Nationality</div>
                            <div class="w-1/2 border-r border-ternary px-2 py-1  flex items-center">{{
                                item.current_nationality }}</div>
                        </div>
                        <div class="w-1/2 flex flex-row">
                            <div class="w-1/2 font-bold border-r border-ternary px-2 py-1  flex items-center">Previous
                                Nationality</div>
                            <div class="w-1/2 px-2 py-1  flex items-center">{{ item.previous_nationality }}</div>
                        </div>
                    </div>
                    <div class="flex flex-row border-b border-ternary flex-grow">
                        <div class="w-1/2 flex flex-row">
                            <div class="w-1/2 font-bold border-r border-ternary px-2 py-1  flex items-center">Mobile
                                Number</div>
                            <div class="w-1/2 border-r border-ternary px-2 py-1  flex items-center">{{
                                item.mobile_number }}</div>
                        </div>
                        <div class="w-1/2 flex flex-row">
                            <div class="w-1/2 font-bold border-r border-ternary px-2 py-1  flex items-center">Date of
                                Birth</div>
                            <div class="w-1/2 px-2 py-1  flex items-center">{{ getDateOfBirth }}</div>
                        </div>
                    </div>
                    <div class="flex flex-row flex-grow">
                        <div class="w-1/4 font-bold border-r border-ternary px-2 py-1  flex items-center">Email</div>
                        <div class="w-3/4 px-2 py-1  flex items-center">{{ item.email }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-8 overflow-x-auto">
            <table class="min-w-full bg-white border border-gray-300">
                <thead>
                    <tr class="bg-ternary">
                        <th colspan="6" class="border border-ternary">
                            <h1 class="text-2xl font-bold text-white text-left px-4 py-2">Educational Qualification</h1>
                        </th>
                    </tr>
                    <tr>
                        <th class="py-2 px-4 border border-ternary">Qualification</th>
                        <th class="py-2 px-4 border border-ternary">University / Institute</th>
                        <th class="py-2 px-4 border border-ternary">Country</th>
                        <th class="py-2 px-4 border border-ternary">Completion Year</th>
                        <th class="py-2 px-4 border border-ternary">Mode of Study</th>
                        <th class="py-2 px-4 border border-ternary">Equivalency from UAE Ministry of Higher Education
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in item.educational_qualifications" :key="index">
                        <td class="py-2 px-4 border border-ternary">{{ item.qualification }}</td>
                        <td class="py-2 px-4 border border-ternary">{{ item.university_or_institute }}</td>
                        <td class="py-2 px-4 border border-ternary">{{ item.country }}</td>
                        <td class="py-2 px-4 border border-ternary">{{ item.completion_year }}</td>
                        <td class="py-2 px-4 border border-ternary">{{ item.mode_of_study }}</td>
                        <td class="py-2 px-4 border border-ternary">{{ item.equivalancy_status }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="mt-8 overflow-x-auto">
            <table class="min-w-full bg-white border border-gray-300">
                <thead>
                    <tr class="bg-ternary">
                        <th colspan="2" class="border border-ternary">
                            <h1 class="text-2xl font-bold text-white text-left px-4 py-2">Professional Certificates</h1>
                        </th>
                    </tr>
                    <tr>
                        <th class="py-2 px-4 border border-ternary">Qualification</th>
                        <th class="py-2 px-4 border border-ternary">Completion Year</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in item.professional_certificates" :key="index">
                        <td class="py-2 px-4 border border-ternary">{{ item.certificate }}</td>
                        <td class="py-2 px-4 border border-ternary">{{ item.completion_year }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="mt-8 overflow-x-auto">
            <table class="min-w-full bg-white border border-gray-300">
                <thead>
                    <tr class="bg-ternary">
                        <th colspan="4" class="border border-ternary">
                            <h1 class="text-2xl font-bold text-white text-left px-4 py-2">Current Employment</h1>
                        </th>
                    </tr>
                    <tr>
                        <th class="py-2 px-4 border border-ternary">Job Title</th>
                        <th class="py-2 px-4 border border-ternary">Employer</th>
                        <th class="py-2 px-4 border border-ternary">City</th>
                        <th class="py-2 px-4 border border-ternary">Number of years of experience</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in item.current_employments" :key="index">
                        <td class="py-2 px-4 border border-ternary">{{ item.job_title }}</td>
                        <td class="py-2 px-4 border border-ternary">{{ item.employer }}</td>
                        <td class="py-2 px-4 border border-ternary">{{ item.city }}</td>
                        <td class="py-2 px-4 border border-ternary">{{ item.years_of_experience }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="mt-8 flex flex-col border border-ternary">
            <h1 class="text-2xl font-bold bg-ternary text-white px-4 py-2">Areas of specialization that you can teach
            </h1>
            <div class="flex flex-row flex-wrap">
                <div class="w-1/2 flex flex-col border-r border-ternary">
                    <h1 class="text-center font-bold px-4 py-2 border-b border-ternary">Fatima College of Health
                        Sciences</h1>
                    <div v-for="(item, index) in fchsAreaOfSpecializationsArray" :key="index"
                        :class="getFchsClass(index)" class="border-ternary px-4 py-2">{{ item }}</div>
                </div>
                <div class="w-1/2 flex flex-col">
                    <h1 class="text-center font-bold px-4 py-2 border-b border-ternary">Abu Dhabi Polytechnic</h1>
                    <div v-for="(item, index) in adpolyAreaOfSpecializationsArray" :key="index"
                        :class="getAdpolyClass(index)" class="border-ternary px-4 py-2">{{ item }}</div>
                </div>
            </div>
        </div>
        <div class="mt-8 overflow-x-auto">
            <table class="min-w-full bg-white border border-gray-300">
                <thead>
                    <tr class="bg-ternary">
                        <th colspan="3" class="border border-ternary">
                            <h1 class="text-2xl font-bold text-white text-left px-4 py-2">Availability to teach</h1>
                        </th>
                    </tr>
                    <tr>
                        <th class="py-2 px-4 border border-ternary">Day</th>
                        <th class="py-2 px-4 border border-ternary text-center">AM</th>
                        <th class="py-2 px-4 border border-ternary text-center">PM</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in filteredAvailabilityToTeach" :key="index">
                        <td class="py-2 px-4 border border-ternary">{{ item.day }}</td>
                        <td class="py-2 px-4 border border-ternary">
                            <div class="flex justify-center">
                                <icon-check v-if="item.am_value" class="h-6 w-6"></icon-check>
                                <icon-close-new v-else class="h-6 w-6"></icon-close-new>
                            </div>
                        </td>
                        <td class="py-2 px-4 border border-ternary">
                            <div class="flex justify-center">
                                <icon-check v-if="item.pm_value" class="h-6 w-6"></icon-check>
                                <icon-close-new v-else class="h-6 w-6"></icon-close-new>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="mt-8 overflow-x-auto">
            <table class="min-w-full bg-white border border-gray-300">
                <thead>
                    <tr class="bg-ternary">
                        <th colspan="4" class="border border-ternary">
                            <h1 class="text-2xl font-bold text-white text-left px-4 py-2">Uploaded Documents</h1>
                        </th>
                    </tr>
                    <tr>
                        <th class="py-2 px-4 border border-ternary text-center">#</th>
                        <th class="py-2 px-4 border border-ternary text-center">Attachment Type</th>
                        <th class="py-2 px-4 border border-ternary text-center">View</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="py-2 px-4 border border-ternary text-center">1</td>
                        <td class="py-2 px-4 border border-ternary text-center">CV</td>
                        <td class="py-2 px-4 border border-ternary">
                            <div class="flex justify-center">
                                <icon-eye class="h-6 w-6 cursor-pointer hover:text-twelve"
                                    @click.stop="showCvPreview = true"></icon-eye>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-if="item.adjunct_faculty_approval && item.adjunct_faculty_approval.note"
            class="mt-8 flex flex-col border border-ternary">
            <h1 class="text-2xl font-bold bg-ternary text-white px-4 py-2">Note</h1>
            <div class="px-4 py-2">{{ item.adjunct_faculty_approval.note }}</div>
        </div>

        <transition name="fade" mode="out-in">
            <base-full-modal v-if="showCvPreview" :title="`View CV`" @close="showCvPreview = false">
                <iframe v-if="item.cv_url" :src="getCv" width="100%" :height="getIframeHeight" frameborder="0"></iframe>
            </base-full-modal>
        </transition>
    </div>
</template>

<script>
import { formattedDate } from "../../helpers/utils";
import IconCheck from "../../components/icons/IconCheck.vue";
import IconCloseNew from "../../components/icons/IconCloseNew.vue";
import IconEye from "../../components/icons/IconEye.vue";
export default {
    name: "adjunct-faculty-view",
    props: ["item"],
    components: {
        IconCheck,
        IconCloseNew,
        IconEye,
    },
    data() {
        return {
            showCvPreview: false,
        };
    },
    computed: {
        fchsAreaOfSpecializationsArray() {
            return this.item.fchs_area_of_specializations.split(',');
        },
        adpolyAreaOfSpecializationsArray() {
            return this.item.adpoly_area_of_specializations.split(',');
        },
        filteredAvailabilityToTeach() {
            return this.item.availability_to_teach.filter(item => item.am_value || item.pm_value);
        },
        getIframeHeight() {
            return `${window.innerHeight} px`;
        },
        getProfilePicture() {
            return process.env.VUE_APP_PUBLIC_URL + this.item.profile_picture_url;
        },
        getDateOfBirth() {
            return formattedDate(this.item.date_of_birth);
        },
        getCv() {
            return process.env.VUE_APP_PUBLIC_URL + this.item.cv_url;
        },
    },
    methods: {
        getFchsClass(index) {
            if (this.fchsAreaOfSpecializationsArray.length - 1 == index) {
                if (this.adpolyAreaOfSpecializationsArray.length > this.fchsAreaOfSpecializationsArray.length) {
                    return "border-b";
                } else {
                    return "";
                }
            } else {
                return "border-b";
            }
        },
        getAdpolyClass(index) {
            if (this.adpolyAreaOfSpecializationsArray.length - 1 == index) {
                if (this.fchsAreaOfSpecializationsArray.length > this.adpolyAreaOfSpecializationsArray.length) {
                    return "border-b";
                } else {
                    return "";
                }
            } else {
                return "border-b";
            }
        },
    },
}
</script>